// Object.entries, but preserves key type
export function entries<K extends string, V>(
    record: Partial<Record<K, V>>
): [K, V][] {
    return Object.entries(record) as [K, V][];
}

// Object.keys, but preserves key type
export function keys<K extends string>(
    record: Partial<Record<K, unknown>>
): K[] {
    return Object.keys(record) as K[];
}

// Object.fromEntries, but preserves key type
export function fromEntries<K extends string, V>(
    entries: [K, V][]
): Record<K, V> {
    return Object.fromEntries(entries) as Record<K, V>;
}
